import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ORIGIN_URL } from './constants/baseurl.constants';
import { AUTH_CONFIG } from './auth0-variables';
import { tokenNotExpired } from 'angular2-jwt';

// Avoid name not found warnings
var auth0 = require('auth0-js');

interface ApiToken {
    apiId: string;
    token: string;
}

@Injectable()
export class AuthService {
    // Create Auth0 web auth instance
    auth0 = new auth0.WebAuth({
        clientID: AUTH_CONFIG.CLIENT_ID,
        domain: AUTH_CONFIG.CLIENT_DOMAIN,
        leeway: 10
    });
    // Create a stream of logged in status to communicate throughout app
    loggedIn: boolean;
    loggedIn$ = new BehaviorSubject<boolean>(this.loggedIn);

    userProfile: any;

    constructor(private router: Router, @Inject(ORIGIN_URL) private baseUrl: string) {
        // If authenticated, set local profile property and update login status subject
        if (this.authenticated) {
            this.setLoggedIn(true);
        }
        try {
            this.userProfile = JSON.parse(localStorage.getItem('profile'));
        } catch (e) {
            this.userProfile = undefined;
        }
    }

    public hasPermission(permission: string) {
        let hasPerm: boolean = false;
        if (this.userProfile && this.userProfile["https://auth.subsite.io/permissions"]) {
            for (let perm of this.userProfile["https://auth.subsite.io/permissions"]) {
                if (perm == permission) {
                    hasPerm = true;
                }
            }
        }
        return hasPerm;
    }

    setLoggedIn(value: boolean) {
        // Update login status subject
        this.loggedIn$.next(value);
        this.loggedIn = value;
    }

    login() {
        // Auth0 authorize request
        // Note: nonce is automatically generated: https://auth0.com/docs/libraries/auth0js/v8#using-nonce
        this.auth0.authorize({
            responseType: 'token id_token',
            redirectUri: this.baseUrl + AUTH_CONFIG.REDIRECT,
            audience: AUTH_CONFIG.AUDIENCE,
            scope: AUTH_CONFIG.SCOPE,
            connection: 'myditchwitch',
            allowSignUp: false,
            allowForgotPassword: false
        });
    }

    handleAuth() {
        // When Auth0 hash parsed, get profile
        this.auth0.parseHash((err, authResult) => {
            if (authResult) {
                window.location.hash = '';
                this.setLoggedIn(true);
                localStorage.setItem('token', authResult.accessToken);
                localStorage.setItem('id_token', authResult.idToken);

                let route = localStorage.getItem('auth_redirect');
                if (route == null) {
                    route = '/';
                }

                this._getProfile(authResult);
                

                this.router.navigate([route]);
                console.log('Auth result received');
            } else if (err) {
                this.router.navigate(['/']);
                console.error(`Auth result Error: ${err.error}`);
            } else {
                console.log('No auth result');
                let route = localStorage.getItem('auth_redirect');
                if (route != null) {
                    this.router.navigate([route]);
                }
            }
        });
    }

    private _getProfile(authResult) {
        // Use access token to retrieve user's profile and set session
        this.auth0.client.userInfo(authResult.accessToken, (err, profile) => {
            localStorage.setItem('profile', JSON.stringify(profile));
            this.userProfile = profile;
            let route = localStorage.getItem('auth_redirect');
            if (route != null) {
                this.router.navigate([route]);
            }
        });
    }
    
    logout() {
        // Remove tokens and profile and update login status subject
        localStorage.removeItem('token');
        localStorage.removeItem('id_token');
        localStorage.removeItem('profile');
        localStorage.removeItem('auth_redirect');
        localStorage.removeItem('auth_api');
        localStorage.removeItem('auth_api_tokens');
        this.userProfile = undefined;

        this.setLoggedIn(false);
        this.auth0.logout({
            returnTo: this.baseUrl,
            client_id: AUTH_CONFIG.CLIENT_ID
        });
    }

    get authenticated() {
        // Check if there's an unexpired access token
        return tokenNotExpired('token');
    }
}



// WEBPACK FOOTER //
// ./Client/app/shared/auth.service.ts